<template>
  <v-row class="social py-12" no-gutters>
    <v-col md="6" offset-md="3">
      <v-row class="text-center" no-gutters>
        <v-col cols="4">
          <v-btn class="mx-2 rotation" outlined fab dark large color="white" href="https://www.instagram.com/yohannhamonic/" target="_blank" aria-label="Instagram" role="img" aria-hidden="false">
            <v-icon>fab fa-instagram</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="4">
          <v-btn class="mx-2 rotation" outlined fab dark large color="green lighten-1" href="https://www.flickr.com/photos/113327493@N05/albums" target="_blank" aria-label="Flickr" role="img" aria-hidden="false">
            <v-icon>fab fa-flickr</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="4">
          <v-btn class="mx-2 rotation" outlined fab dark large color="white" href="https://www.facebook.com/Y.HamoPhotos/" target="_blank" aria-label="Facebook" role="img" aria-hidden="false">
            <v-icon>fab fa-facebook</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="text-center pt-3" no-gutters>
        <v-col cols="4">
          <p class="subtitle-2 font-weight-medium text-uppercase white--text mb-0">Instagram</p>
        </v-col>
        <v-col cols="4">
          <p class="subtitle-2 font-weight-medium text-uppercase green--text text--lighten-1 mb-0">Portfolio</p>
        </v-col>
        <v-col cols="4">
          <p class="subtitle-2 font-weight-medium text-uppercase white--text mb-0">Facebook</p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "social",
};
</script>

<style scoped>
.social {
  background: #3F3E40;
}
.rotation {
    overflow: hidden;
    transition-duration: 0.3s;
    transition-property: transform;
}
.rotation:hover {
    transform: rotate(-40deg);
    -webkit-transform: rotate(-40deg);
}
</style>